export default "__VITE_ASSET__BtCvumGg__"